module.exports = __webpack_public_path__ + "img/main_05_product_img_04@2x.dc0e896e.png";